import { render, staticRenderFns } from "./InsurancesPlanNameTable.vue?vue&type=template&id=66569b62&"
import script from "./InsurancesPlanNameTable.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports